export default __webpack_public_path__ + "static/media/mpya-digital-logo.fd39f862.svg";